// 加载微服务的语言
// const { zhCN } = await import('userCommon/locales')
import antd from 'ant-design-vue/lib/locale-provider/zh_CN'
import { fetchAndDecompressJson } from '@ost/static/lib/common/lang'

export default async function getMessageByLang () {
  // 后台翻译配置保存后点击刷新生成
  const i18nMessage = await fetchAndDecompressJson(
    `${
      process.env.VUE_APP_LANG_S3_URL
    }/merc/lang/zh-CN.json?v=${Math.random()}`
  ).catch(e => {
    console.log(e)
    return {}
  })

  let {
    buyList,
    vat,
    invoice,
    register,
    forgetPwd,
    loginList,
    layouts,
    remote,
    eprDeclare,
    onlinePayment,
    eprRegistrationNumber,
    tools,
    utils,
    lawIppBusiness,
    dashboard,
    Table,
    renewal,
    carbonFootprint,
    land8
  } = i18nMessage

  console.log(remote, '>>>><<<<<<<<<<<<<<<<<<')
  console.log(remote, 'xxxxxxxxxx')

  return {
    antd,
    remote,
    invoice,
    layouts,
    register,
    buyList,
    forgetPwd,
    loginList,
    vat,
    eprDeclare,
    onlinePayment,
    eprRegistrationNumber,
    tools,
    utils,
    lawIppBusiness,
    dashboard,
    Table,
    renewal,
    carbonFootprint,
    land8
  }
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/index.js